module.exports = __webpack_public_path__ + "static/76b8cda6-0ded-4197-acab-e314297eb90f-898b516fc3d37922f10a3560106be977.woff2";